import { ErrorMessage, Field, FormikProvider, useFormik, Form } from 'formik';
import { useState, useEffect, React, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { store } from "../App.jsx";
import { FaArrowUp, FaEye, FaEyeSlash, FaLongArrowAltUp } from "react-icons/fa";
import { TbRefresh } from "react-icons/tb";
import ShowAlert from "./alert.jsx";
import SwaranandhraService from "../Services/SwaranandhraService.jsx";
import { BiLock, BiUser } from "react-icons/bi";
import { Container, Nav, Navbar, Modal, Row, InputGroup, NavDropdown, Col, Carousel } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import '../main-page.css'
import '../vision-carousel.css'
// import SliderComponent from "./SliderComponent.jsx";
import { Link } from "@mui/material";
import KpiService from '../Services/KpiService.jsx';
import { tns } from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import Button from 'react-bootstrap/Button';
import WavingCircleFlag from './CircleFlag.jsx';
import { FaArrowRightLong } from "react-icons/fa6";
import SliderImport from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MasterService from '../Services/MasterService.jsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import AccessibilityTools from './AccessibilityToolbar.jsx';
import TranslatorPopup from './TranslatorPopup.jsx';
import { FiSearch } from 'react-icons/fi';
import NewFooter from './FooterBottom.jsx';
// aaaaaaaaaaaaa
export default function SwarnandhraLogin() {

  const SliderComponent = SliderImport?.default || SliderImport;

  const navigate = useNavigate();

  const [passwordType, setPasswordType] = useState('password');
  const [show, setShow] = useState(false);
  const [Captchadata, setCaptchadata] = useState()
  const [sessionId, setSessionId] = useState()
  const [addModal, setAddmodal] = useState(true)
  const [deptKpiCount, setDeptKpiCount] = useState([]);

  const initialValues = {
    username: '',
    password: '',
    captcha: ''
  };
  const CaptchaRefresh = () => {
    SwaranandhraService.getCaptcha().then((res) => {
      setCaptchadata(res.data.captchaImageBase64);
      setSessionId(res.data.sessionId);

    });
  };
  const handleClose = () => {
    formik.resetForm();
    setShow(false);

  }



  const handleShow = () => {
    CaptchaRefresh();
    setShow(true);
  }
  const disableBackButton = () => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function (event) {
      window.history.go(1);
    };
  };

  const handleKeyDown = (event) => {
    if (show && event.key === 'Enter' || event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
    }

    if (event.key === 'Tab') {
      event.preventDefault();
      const focusableElements = Array.from(document.querySelectorAll("input, button, select, textarea, a"));
      const index = focusableElements.indexOf(document.activeElement);

      if (index > -1 && index < focusableElements.length - 1) {
        focusableElements[index + 1].focus();
      }
    }
  };




  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {
      let params = { "username": values.username, "password": values.password, "capchaId": values.captcha, sessionId: sessionId }
      if (!params.username) {
        ShowAlert("Enter Username", "warning");
        return
      }
      if (!params.password) {
        ShowAlert("Enter Password", "warning");
        return
      }
      if (!params.capchaId || params.capchaId === "") {
        ShowAlert("Enter Captcha", "warning");
        return
      }
      store.dispatch({ type: "SHOW_SPINNER" })
      SwaranandhraService.loginDetails(params).then((response) => {

        if (response?.data !== "" && response?.data !== null && response?.data !== undefined) {
          if (response.data?.token) {
            const userRoleId = String(response?.data?.SDESC?.roleid);
            console.log("Converted roleId:", userRoleId);
            KpiService.getrolecategory().then((res) => {
              const roleCategories = res?.data || [];
              const matchedCategory = roleCategories.find(category =>
                category.roleIds.includes(userRoleId)
              );
              if (matchedCategory) {
                localStorage.setItem("catid", matchedCategory.roleCatId);
                console.log("Matched categoryName:", matchedCategory.roleCatId);
              } else {
                console.warn("No matching role found for roleid:", userRoleId);
              }
            });

            let params = { deptId: "MAU01" }
            KpiService.getDeptartmentsWithoutToken(params).then((res) => {
              if (res.data.SCODE === "01") {
                let response = res.data?.SDESC;
                const deptCodeList = response.map(item => item.deptcode.toString());
                localStorage.setItem("ulbdeptlist", JSON.stringify(deptCodeList));
              }



            });
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("Module", JSON.stringify(response?.data?.modulesList));
            localStorage.setItem("SubModule", JSON.stringify(response?.data?.submodulesList));
            localStorage.setItem("Menu", JSON.stringify(response?.data?.menu));
            localStorage.setItem("token", response.data?.token);
            localStorage.setItem("captcha", values.captcha);
            localStorage.setItem("sessionId", sessionId);
            localStorage.setItem("username", response?.data?.SDESC?.userid);
            localStorage.setItem("dispName", response?.data?.SDESC?.dispname);
            localStorage.setItem("mandalname", response?.data?.SDESC?.mandal_name);
            localStorage.setItem("districtname", response?.data?.SDESC?.district_name);
            localStorage.setItem("ulbid", response?.data?.SDESC?.ulb_id);
            localStorage.setItem("ulbname", response?.data?.SDESC?.ulb_name);
            localStorage.setItem("role", response?.data?.SDESC?.roleid);
            // localStorage.setItem("password", values.password);
            localStorage.setItem("districtid", response?.data?.SDESC?.district_id);
            localStorage.setItem("mandalid", response?.data?.SDESC?.mandal_id);
            localStorage.setItem("villageid", response?.data?.SDESC?.village_id);
            localStorage.setItem("lastlogintime", response?.data?.SDESC?.lastloggedintime);
            localStorage.setItem("phone", response?.data?.SDESC?.phone);
            localStorage.setItem("deptid", response?.data?.SDESC?.dept_id);
            localStorage.setItem("deptName", response?.data?.SDESC?.dept_name);
            localStorage.setItem("SectariatName", response?.data?.SDESC?.secretariat_name);
            localStorage.setItem("secretariat_code", response?.data?.SDESC?.secretariat_code);
            localStorage.setItem("assemblyid", response?.data?.SDESC?.assembly_id);
            localStorage.setItem("assemblyname", response?.data?.SDESC?.assembly_name);
            localStorage.setItem("sec_dept_id", response?.data?.SDESC?.sec_dept_id);
            localStorage.setItem("password_updated_days", response?.data?.SDESC?.password_updated_days);
            localStorage.setItem("Isvaliduser", response?.data?.SDESC?.is_valid_user);
            localStorage.setItem("Menu", JSON.stringify(response?.data?.menu));
            // localStorage.setItem("Passwd", response?.data?.SDESC?.password);
            localStorage.setItem("userType", response?.data?.SDESC?.user_type);
            localStorage.setItem("nodelOfficerMapService", response?.data?.nodelOfficerMapService);

            localStorage.setItem("SectariatcodeName", response?.data?.SDESC?.secretariat_code + '-' + response?.data?.SDESC?.secretariat_name);

            localStorage.setItem("countdown", 2400);
            localStorage.setItem("Login", "main");
            localStorage.setItem("dashboardDataForSwarnaAndhraKPIslist", JSON.stringify(response?.data?.dashboardDataForSwarnaAndhraKPIs));
            localStorage.setItem("mandal_indicators", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.mandal_indicators);
            localStorage.setItem("district_indicators", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.district_indicators);
            localStorage.setItem("state_indicators", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.state_indicators);
            localStorage.setItem("secretariat_indicators", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.secretariat_indicators);
            localStorage.setItem("total", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.total);
            localStorage.setItem("monthly", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.monthly);
            localStorage.setItem("quarterly", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.quarterly);
            localStorage.setItem("half_yearly", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.half_yearly);
            localStorage.setItem("five_years", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.five_years);
            localStorage.setItem("bi_annual", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.bi_annual);
            localStorage.setItem("annually", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.annually);
            localStorage.setItem("hod_id", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.hod_id);
            localStorage.setItem("showNotificationBanner", "false");
            localStorage.setItem("Moduleid", null);
            // localStorage.setItem("fileuserid", "FILES_DES");
            // localStorage.setItem("filepassword", "@p$hcl@2k26");
            localStorage.setItem("deptcodeName", response?.data?.dashboardDataForSwarnaAndhraKPIs[0]?.hod_id + '-' + response?.data?.SDESC?.dept_name);
            window.dispatchEvent(new Event("loginSuccess"));
            store.dispatch({ type: "HIDE_SPINNER" })
          }
          if (response?.data?.SCODE === "01") {
            const passwordUpdatedDays = response?.data?.SDESC?.password_updated_days;
            const phone = response?.data?.SDESC?.phone;
            const Isvaliduser = response?.data?.SDESC?.is_valid_user;

            if (passwordUpdatedDays > 180 || Isvaliduser === false) {
              if (phone === null) {
                ShowAlert("Mobile number is empty,Please Contact Adminstration", "warning").then(() => {
                  let params1 = {
                    token: localStorage.getItem("token")
                  }
                  SwaranandhraService.userLogout(params1).then(() => {

                    navigate("/SwarnandhraLogin");
                    localStorage.removeItem("token");
                    localStorage.removeItem("serviceList");
                    localStorage.clear();
                  })
                })


              }
              navigate("/UpdatePassword");
            } else {
              navigate("/Menubar");
            }

            if (response.data?.token) {

              store.dispatch({ type: "HIDE_SPINNER" })
            }
          } else {
            store.dispatch({ type: "HIDE_SPINNER" })
            ShowAlert(response?.data?.SDESC, "warning").then(() => {
              SwaranandhraService.getCaptcha().then((res) => {
                setCaptchadata(res.data.captchaImageBase64);
                setSessionId(res.data.sessionId);
                formik.setFieldValue("captcha", "")
              })

            })
          }
        }
        return response.data;
      })
    }
  });

  useEffect(() => {
    disableBackButton();
    SwaranandhraService.getCaptcha().then((res) => {
      setCaptchadata(res.data.captchaImageBase64);
      setSessionId(res.data.sessionId);
    });
    MasterService.loginkpicount().then((count) => {
      if (count.data.SCODE === "01") {
        setDeptKpiCount(count.data.SDESC)
      }
    })
  }, []);
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }


  const [index, setIndex] = useState(0);

  const slides = [
    { heading: "Track Progress Across Vision Goals", text: "Monitor real-time progress of key development indicators aligned with Swarna Andhra @ 2047 goals, including economic growth, infrastructure, social welfare, and sectoral targets." },
    { heading: "Enable Data-Driven Governance", text: "Support government decision-making through structured, evidence-based insights derived from field-level data collected at mandal, constituency, and district levels and the data pulled from the national websites and Journals of repute." },
    { heading: "Facilitate Multi-Level Monitoring", text: "Provide visibility into implementation status across administrative levels—mandal, municipality, constituency, district, and state—ensuring coordinated execution of action plans." },
    { heading: "Measure Performance Through KPIs", text: "Evaluate the effectiveness of schemes and initiatives using Key Performance Indicators (KPIs), including sectoral growth, service delivery, and Sustainable Development Goals (SDGs)." },
    { heading: "Support Timely Policy Interventions", text: "Enable early identification of gaps and bottlenecks, allowing for timely corrective actions and policy adjustments to improve outcomes." },
    { heading: "Visualize Development Trends", text: "Provide intuitive dashboards and visual analytics to help stakeholders understand trends, compare performance, and forecast future progress." },
    // { heading: "Women's Empowerment", text: "Providing equal rights and opportunities for women across all sectors." },
    // { heading: "Business Growth", text: "Supporting startups and established businesses to make India a global business hub." },
  ];
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const handlePrev = () => {
    const prevIndex = index === 0 ? slides.length - 1 : index - 1;
    setIndex(prevIndex);
  };

  const handleNext = () => {
    const nextIndex = index === slides.length - 1 ? 0 : index + 1;
    setIndex(nextIndex);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 2200,
        settings: { slidesToShow: 3, slidesToScroll: 1, },
      },
      {
        breakpoint: 1400, settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slider = [
    { id: 1, content: "The Government of Andhra Pradesh has embarked on an ambitious mission to achieve a 15% annual growth rate, aiming to transform the state into a $2.4 trillion economy with a per capita income of $42,000 by 2047." },
    { id: 2, content: "To track the progress of these initiatives and ensure timely course correction, the Government of Andhra Pradesh has launched a dedicated Key Performance Indicator (KPI) Portal." },
    { id: 3, content: "The Government of Andhra Pradesh has embarked on an ambitious mission to achieve a 15% annual growth rate, aiming to transform the state into a $2.4 trillion economy with a per capita income of $42,000 by 2047." },
    { id: 4, content: "To track the progress of these initiatives and ensure timely course correction, the Government of Andhra Pradesh has launched a dedicated Key Performance Indicator (KPI) Portal." },
    { id: 5, content: "The Government of Andhra Pradesh has embarked on an ambitious mission to achieve a 15% annual growth rate, aiming to transform the state into a $2.4 trillion economy with a per capita income of $42,000 by 2047." },
  ];

  // -----------------------Tiny slider---------------------------
  const [newsAndEvents, setNewsAndEvents] = useState([]);
  const [circularAndGos, setCircularAndGos] = useState([]);

  useEffect(() => {
  }, []);

  const sliderRef = useRef(null);

  useEffect(() => {


    if (sliderRef.current) {
      const slider = tns({
        container: ".slider",
        items: 4,
        autoplay: true,
        autoplayTimeout: 3000,
        mouseDrag: true,
        swipeAngle: false,
        speed: 500,
        controls: true,
        controlsContainer: false,
        prevButton: '.custom-prev',
        nextButton: '.custom-next',
        nav: false,
        gutter: 20,
        autoplayButtonOutput: false,
        responsive: {
          150: { items: 1, gutter: 10 },
          344: { items: 1, gutter: 10 },
          360: { items: 2, gutter: 10 },
          568: { items: 2, gutter: 10 },
          768: { items: 2, gutter: 15 },
          992: { items: 3, gutter: 15 },
          1024: { items: 3, gutter: 20 },
          1366: { items: 3, gutter: 20 },
          1440: { items: 4, gutter: 20 },
        },
      });

      return () => slider.destroy();
    }
  }, []);

  // modal popup
  const [padiOneShow, padiOne] = useState(false);
  const [padiTwoShow, padiTwo] = useState(false);
  const [padiThreeShow, padiThree] = useState(false);
  const [padiFourShow, padiFour] = useState(false);
  const [padiFiveShow, padiFive] = useState(false);
  const [padiSixShow, padiSix] = useState(false);
  const [padiSevenShow, padiSeven] = useState(false);
  const [padiEightShow, padiEight] = useState(false);
  const [padiNineShow, padiNine] = useState(false);
  const [padiTenShow, padiTen] = useState(false);
  // modal popup
  // ------------------------------------------------------------------

  const initsliders = [
    { id: "AGC01", title: "Agriculture Marketing & Cooperation Secretariat", path: "../images/KeyIcons/key-agriculture.png" },
    { id: "ENE01", title: "Energy and Infrastructure Secretariat", path: "../images/KeyIcons/key-energy.png" },
    { id: "AHF01", title: "Animal Husbandry, Dairy Development & Fisheries Secretariat", path: "../images/KeyIcons/key-animal.png" },
    { id: "EFS01", title: "Environment, Forest, Science & Technology Secretariat​", path: "../images/KeyIcons/key-environment.png" },
    { id: "BCW01", title: "Backward Classes Welfare Secretariat", path: "../images/KeyIcons/key-backward.png" },
    { id: "FIN01", title: "Finance Secretariat", path: "../images/KeyIcons/key-finance.png" },
    { id: "FCS01", title: "Food & Civil Supplies Secretariat", path: "../images/KeyIcons/key-food-civil.png" },
    { id: "HOM01", title: "Home Secretariat", path: "../images/KeyIcons/key-home-secretariat.png" },
    { id: "HMF01", title: "Health Medical & Family Welfare Secretariat", path: "../images/KeyIcons/key-health-medical.png" },
    { id: "HOU01", title: "Housing Secretariat", path: "../images/KeyIcons/key-housing-secretariat.png" },
    { id: "EHE01", title: "Higher Education Secretariat​", path: "../images/KeyIcons/key-higher-education.png" },
    { id: "INC01", title: "Industries and Commerce Secretariat​", path: "../images/KeyIcons/key-industries-commerce.png" },
    { id: "ITC01", title: "Information Technology, Electronics & Communications Secretariat​", path: "../images/KeyIcons/key-information-technology-electronics.png" },
    { id: "ESE01", title: "Secondary Education Secretariat", path: "../images/KeyIcons/key-secondary-education.png" },
    { id: "INI01", title: "Infrastructure and Investment Secretariat​", path: "../images/KeyIcons/key-infra-investment.png" },
    { id: "SEI01", title: "Skill Development, Entrepreneurship and Innovation Secretariat​", path: "../images/KeyIcons/key-skill-development.png" },
    { id: "LAE01", title: "Labour & Employment Secretariat​", path: "../images/KeyIcons/key-labour-employment.png" },
    { id: "MNW01", title: "Minorities Welfare Secretariat​", path: "../images/KeyIcons/key-minorities-welfare.png" },
    { id: "MAU01", title: "Municipal Administration & Urban Development Secretariat", path: "../images/KeyIcons/key-municipal-urban-development.png" },
    { id: "REV01", title: "Revenue Secretariat​", path: "../images/KeyIcons/key-revenue.png" },
    { id: "PRR01", title: "Panchayat Raj and Rural Development Secretariat​", path: "../images/KeyIcons/key-panchayat-raj.png" },
    { id: "TRB01", title: "Transport, Roads and Buildings Secretariat​", path: "../images/KeyIcons/key-transport-roads.png" },
    { id: "PLG01", title: "Planning Secretariat​", path: "../images/KeyIcons/key-planning-secretariat.png" },
    { id: "ICD01", title: "Water Resources Secretariat​", path: "../images/KeyIcons/key-water-resources.png" },
    { id: "WDC01", title: "Women, Children, Disabled and Senior Citizens Secretariat", path: "../images/KeyIcons/key-women-children-senior.png" },
    { id: "SOW01", title: "Social Welfare Secretariat​", path: "../images/KeyIcons/key-social-welfare.png" },
    { id: "TBW01", title: "Tribal Welfare Secretariat​", path: "../images/KeyIcons/key-tribal-welfare.png" },
    { id: "YTC01", title: "Youth and Sports Secretariat​​", path: "../images/KeyIcons/key-youth-sports.png" },
  ];

  // Assuming deptKpiCount is available in your component's props or state
  const slidesnew = initsliders.map(slide => {
    const match = deptKpiCount?.find(item => item.secretariat_code === slide.id);
    return {
      ...slide,
      count: match ? match.ind_count : "-"
    };
  });

  const downloadFile = async (fileName) => {
    try {
      const response = await MasterService.getGoPdf(fileName);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);

      // Open in new tab (view PDF)
      window.open(url, "_blank");

      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Something went wrong while downloading the file.");
    }
  };

  const formatGoDate = (dateStr) => {
    if (!dateStr) return { day: "", month: "" };

    const date = new Date(dateStr);

    return {
      day: String(date.getDate()).padStart(2, "0"),
      month: date.toLocaleString("en-US", { month: "short" })
    };
  };

  function closing() {
    setAddmodal(false)
  }
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".main-navbar");
      if (window.scrollY > 10) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const topFunction = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // ----------------------------
  const [activeMenu, setActiveMenu] = useState("Home");
  return (
    <>
      {showScroll && (
        <button
          className="scroll-expand-btn"
          onClick={() =>
            window.scrollTo({ top: 0, behavior: "smooth" })
          }
        >
          <span className="icon"><FaLongArrowAltUp /></span>
          <span className="label">Scroll</span>
        </button>
      )}
      <Button
        onClick={topFunction}
        variant="outline-light"
        className="position-fixed bottom-0 end-0 rounded-circle"
        id="myBtn"
        title="Go to top"
        style={{ padding: "10px", display: "none" }}
      >
        <FaArrowUp className="arrow-top" />
      </Button>

      <div className='topstrip'>

        <div className='top-right'>
          <div className='skip-content'>
            <a href='#skip' className='mb-0' title='Skip to main Content'>Skip to Main Content</a>
          </div>

          <div className="divider"></div>

          <AccessibilityTools />

          <div className="divider"></div>

          <TranslatorPopup />
        </div>


      </div>


      <div className='main-content' id="accessibility-wrapper">
        <Navbar expand="lg" className="main-navbar shadow" fixed="top">
          <Container fluid className="p-0 swarna-container">
            <Navbar.Brand href="#home" className="d-flex align-items-center">
              <Link className="navbar-brand d-flex align-items-center ms-2 ms--4">
                <img
                  src="images/swarna-logo.svg"
                  className="swarna-logo"
                  alt="Logo"
                />
              </Link>
            </Navbar.Brand>

            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="border-0 ms-auto"
            />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">

                <Nav.Link
                  as={NavLink}
                  to="/Home"
                  className={activeMenu === "Home" ? "active" : ""}
                  onClick={() => setActiveMenu("Home")}
                >
                  Home
                  <span className="underline"></span>
                </Nav.Link>
                {/* <div
                  className={`lgndrop ${activeMenu === "Downloads" ? "active" : ""
                    }`}
                >
                  <button
                    type="button"
                    className="lgndrop-btn"
                    onClick={() => setActiveMenu("Downloads")}
                  >
                    Downloads <span style={{ fontSize: "12px" }}>▼</span>
                  </button>

                  <div className="lgndrop-content">
                    <a href="/listofkpis">List Of KPIs</a>
                    <a
                      href="/Swarna_Andhra2047_Workshop_Presentation.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Overview
                    </a>
                    <a
                      href="/Swarna_Andhra_KPIs_User_Manual.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      User Manual
                    </a>
                    <a
                      href="/Swarna_Vision_SoP_V2.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Standard Operating Procedure (SoP)
                    </a>
                  </div>
                </div> */}


                <div
                  className={`lgndrop ${activeMenu === "Downloads" ? "active" : ""
                    }`}
                >
                  <button
                    type="button"
                    className="lgndrop-btn"
                    onClick={() => setActiveMenu("Downloads")}
                  >
                    Downloads <span style={{ fontSize: "12px" }}>▼</span>
                  </button>

                  <div className="lgndrop-content">
                    <a href="/listofkpis">List Of KPIs</a>

                    <a
                      href="/Swarna_Andhra2047_Workshop_Presentation.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Overview
                    </a>

                    <a
                      href="/Swarna_Andhra_KPIs_User_Manual.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      User Manual
                    </a>

                    <a
                      href="/Swarna_Vision_SoP_V2.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Standard Operating Procedure (SoP)
                    </a>

                    {/* MER Reports */}
                    <div className="mer-report-menu">
                      <a href="#mer-reports">
                        MER Reports <span style={{ float: "right" }}>▶</span>
                      </a>

                      <div className="mer-report-content">
                        <a
                          href="/MER_June.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          June
                        </a>

                        <a
                          href="/MER_July.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          July
                        </a>
                        <a
                          href="/MER_August.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          August
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <Nav.Link
                  as={NavLink}
                  to="/contact"
                  className={({ isActive }) =>
                    isActive ? "active" : ""
                  }
                  onClick={() => setActiveMenu("Contact")}
                >
                  Contact Us
                  <span className="underline"></span>
                </Nav.Link>
                {/* <Nav.Link
                  as={NavLink}
                  to="/feedbackForm"
                  className={({ isActive }) =>
                    isActive ? "active" : ""
                  }
                  onClick={() => setActiveMenu("Feedback Form")}
                >
                  NCCS Feedback Form
                  <img
                    src="../images/new_gif.gif"
                    alt="New"
                    style={{
                      width: "30px",
                      marginLeft: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                  <span className="underline"></span>
                </Nav.Link> */}


                <Nav.Link className="login pe-0">

                </Nav.Link>
                <Modal onKeyDown={handleKeyDown} tabIndex="0" autoComplete="off" onHide={handleClose} show={show} animation={false} className="login-modal">
                  <Modal.Header closeButton>
                    <Modal.Title>Login</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="p-4"  >
                    <FormikProvider value={formik}>
                      <Form className="loginform form_adjust" onSubmit={formik.handleSubmit}>
                        <Row>
                          <div className="input-group mb-3">
                            <span className="input-group-text">
                              <BiUser className="font_size text-white" />
                            </span>
                            <Field name="username" type="text" className="form-control login-popup" placeholder="Username" style={{ paddingRight: "2.5rem" }} tabIndex={1} />
                            <ErrorMessage name="username" className="text-error" component="div" />
                          </div>

                          <div className="input-group password-popup">
                            <span className="input-group-text">
                              <BiLock className="font_size text-white" />
                            </span>
                            <Field name="password" type={passwordType} className="form-control enter-password" autoComplete="off" placeholder="Password" aria-label="Password" aria-describedby="basic-addon1" style={{ borderRadius: "0px" }} tabIndex={2} />
                            <InputGroup.Text id="basic-addon2" className="group_txt group_txt11">
                              {passwordType === "password" ? <FaEyeSlash style={{ color: "#fff", cursor: "pointer", fontSize: "20px" }} onClick={togglePassword} /> : <FaEye style={{ color: "#fff", cursor: "pointer", fontSize: "20px" }} onClick={togglePassword} />}
                            </InputGroup.Text>
                            <ErrorMessage name="password" className="text-error" component="div" />
                          </div>

                          <div className="mb-2 mt-2">
                            <div className="captcha-image-container d-flex" style={{ marginTop: "10px" }}>
                              <Field name="captcha" type="text" placeholder="Enter captcha" maxLength={5} className="form-control" style={{ borderRadius: "0px" }} tabIndex={3} />
                              <ErrorMessage name="captcha" className="text-error" component="div" />
                              <img style={{ width: "42%", height: "39px" }} src={"data:image/png;base64," + Captchadata} alt="Captcha" />
                              <TbRefresh size={42} style={{ marginLeft: "10px", cursor: "pointer", border: "1px solid #000" }} onClick={CaptchaRefresh} />
                            </div>
                          </div>
                        </Row>
                        <div className="text-end">
                          <button onClick={() => { navigate("/Forgotpassword") }} style={{ fontSize: "14px", fontWeight: "400", color: "black", textDecoration: "none" }}>
                            Forgot Password?
                          </button>
                        </div>
                        <Row className="align-items-center mt-1">
                          <Col md={8}>
                            <img
                              src="/images/devimg1.png"
                              alt="Developer"
                              style={{
                                width: "65%",

                                height: "auto",
                              }}
                            />
                          </Col>

                          <Col md={4} className="text-end">
                            <button
                              type="submit"
                              className="btn login-button"
                              style={{
                                borderRadius: "0",
                                background: "#4e835c",
                                border: "1px solid #444444",
                                color: "#fff",
                                minWidth: "120px",
                              }}
                              tabIndex={4}
                            >
                              Login
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </Modal.Body>
                </Modal>
              </Nav>
            </Navbar.Collapse>
            <button
              className="btn btn-sm login-btn"
              onClick={handleShow}
            >
              Login
              <img
                src="../images/login-arrow.svg"
                className="img-fluid"
                alt="login-arrow"
              />
            </button>
          </Container>
        </Navbar>

        <Container fluid className='p-0'>
          <div className='banner-part'>
            <div className='banner-content'>
              <div className='d-flex justify-content-start ministers-all'>
                <div className='minister-one'>
                  <img src="../images/pm.jpg" className='img-fluid' alt='min-img' />
                </div>
                <div className='minister-one'>
                  <img src="../images/dcm-pk.jpg" className='img-fluid' alt='min-img' />
                </div>
                <div className='minister-one'>
                  <img src="../images/minister-lokesh.png" className='img-fluid' alt='min-img' />
                </div>
                <div className='minister-one'>
                  <img src="../images/min-img.webp" className='img-fluid' alt='min-img' />
                </div>
              </div>
              <div className='banner-row'>
                <div className='banner-text'>
                  <h1>Swarna Andhra<br></br><span>@2047</span></h1>
                  <p>is a strategic vision launched by the Government of Andhra Pradesh to transform the state into a ₹308 lakh crore ($2.4 trillion) economy by the year 2047, with a targeted per capita income of ₹55 lakh. This long-term development plan is aligned with the national vision of Viksit Bharat and aims to achieve sustained annual growth of over 15%. The approach is structured and data-driven, beginning at the mandal level and scaling up through constituency, district, and state-level planning. Sector-specific action plans have been developed to guide progress across key areas such as agriculture, industry, services, infrastructure, social development, and governance.</p>

                </div>
                <div className='cm-image-part'>
                  <img src="../images/CBN-bot.png" className='img-fluid' alt='cm-img' />
                </div>
                <div className="banner-right-total-content">
                  <div className='right-banner-img'>
                    <div className='main-bg'>
                      <div className='position-relative'>
                        <img src='../images/main-bg.png' alt='' className='img-fluid' />
                        <div class="box-canvas">
                          <div class="blade-wrapper">
                            <div class="blade one"></div>
                            <div class="blade two"></div>
                            <div class="blade three"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <img src="../images/earth.svg" className='earth-svg' alt='banner-img' />
                    <div className='wave-flag'>
                      <WavingCircleFlag />
                    </div>
                    <img src='../images/flight.png' alt='' className='img-fluid flight-svg' />
                    <img src='../images/2047.png' alt='' className='img-fluid num-svg' />
                    <div className='wave-flag2'>
                      <WavingCircleFlag />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='vision' id='skip'>
              <div className='vision-slider'>
                <div className='vision-slide-content'>
                  <Carousel activeIndex={index} onSelect={handleSelect} interval={null} controls={false} indicators={false} slide={true} fade={false}>
                    {slides.map((slide, idx) => (
                      <Carousel.Item key={idx}>
                        <div className='vision-text'> <div> <h3>{slide.heading}</h3> <p>{slide.text}</p> </div> </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  <div className='indicators-div'>
                    <div className='numbers-indicator'>{`${index + 1} / ${slides.length}`}</div>
                    <button className='nav-left-arrow' onClick={handlePrev}>
                      <MdOutlineKeyboardArrowLeft className='arrow-line' />
                    </button>
                    <button className='nav-right-arrow' onClick={handleNext}>
                      <MdOutlineKeyboardArrowRight className='arrow-line' />
                    </button>
                  </div>
                </div>
              </div>
              <div className='vision-round'> <h1>Vision & Objectives</h1></div>
            </div>
          </div>
        </Container >

        {/* -------------------- 10 sutralu start ------------------ */}
        <Container className='ten-all'>
          <div className="ten-sutra">
            <h1>Padi Sutralu<br></br><span>Guiding Principles</span></h1>
            <p>To achieve the objectives of Swarna Andhra Vision @ 2047 Hon'ble Chief Minister has proposed Padi Sutralu Guiding Principles which will play a key role in implementation of Vision Action Plan.</p>
          </div>
          <div className="padi-sutralu-div">
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiOne(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiOne(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/1-zeropoverty.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Zero Poverty</p>
                <span role="button" tabIndex={0} onClick={() => padiOne(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiOne(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>
              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiTwo(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiTwo(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/2-PopulationManagement.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p class="population-text">
                  Population Management &amp; Human Resource Development
                </p>
                <span role="button" tabIndex={0} onClick={() => padiTwo(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiTwo(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>
              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiThree(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiThree(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/3-SkillingEmployment.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Skilling & Employment</p>
                <span role="button" tabIndex={0} onClick={() => padiThree(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiThree(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>
              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiFour(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiFour(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/4-WaterSecurity.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Water Security</p>
                <span role="button" tabIndex={0} onClick={() => padiFour(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiFour(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>
              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiFive(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiFive(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/5-FarmerAgri.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Farmer - Agri Tech</p>
                <span role="button" tabIndex={0} onClick={() => padiFive(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiFive(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>
              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiSix(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiSix(true); } }}>
                <div className='sutralu-circle-img'>
                  <img src="../images/6-GlobalLogistics.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Global - Best Logistics</p>
                <span role="button" tabIndex={0} onClick={() => padiSix(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiSix(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiSeven(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiSeven(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/7-CostEnergyFuel.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Cost Optimization - Energy & Fuel</p>
                <span role="button" tabIndex={0} onClick={() => padiSeven(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiSeven(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>
              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiEight(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiEight(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/8-ProductPerfection.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Product Perfection</p>
                <span role="button" tabIndex={0} onClick={() => padiEight(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiEight(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiNine(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiNine(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/9-SwachhAndhra.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Swachh Andhra</p>
                <span role="button" tabIndex={0} onClick={() => padiNine(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiNine(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>

              </div>
            </div>
            <div className="sutralu-box">
              <div role="button" tabIndex={0} className="ten-card" onClick={() => padiTen(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiTen(true); } }} >
                <div className='sutralu-circle-img'>
                  <img src="../images/10-DeepTech.png" className='img-fluid ten-each' alt='min-img' />
                  <img src='../images/padi-arrow.svg' className='img-fluid ten-arrow' alt='login-arrow' />
                </div>
                <p>Deep Tech - all walks of life</p>
                <span role="button" tabIndex={0} onClick={() => padiTen(true)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { padiTen(true); } }} > <img src="../images/padi-zoom.png" className="img-fluid" alt="Zoom" /> </span>              </div>
            </div>
          </div>
        </Container >

        <Container>
          <div className='cm-min-part'>
            <Row>
              <Col xxl={4} xl={5} lg={6} md={12} sm={12} xs={12}>
                <div className='news-slider news-slider-gos'>
                  <h1 className='ms-0'>Circular  & <span>Go's</span></h1></div>
                <div className='gos-all'>
                  <div className='gos'>
                    <div className='gos-text-head'>
                      <h3>15<span>Jul</span></h3>
                    </div>
                    <a href='#'>To track the progress of these initiatives and ensure timely course correction, the Government of Andhra Pradesh has launched a dedicated Key Performance Indicator (KPI) Portal.</a>
                  </div>
                  <div className='gos'>
                    <div className='gos-text-head'>
                      <h3>25<span>Jul</span></h3>
                    </div>
                    <a>Initiatives and ensure timely course correction, the Government of Andhra Pradesh has launched a dedicated Key Performance Indicator (KPI) Portal.</a>
                  </div>
                  <div className='gos'>
                    <div className='gos-text-head'>
                      <h3>29<span>Jul</span></h3>
                    </div>
                    <a>Progress of these initiatives and ensure timely course correction, the Government of Andhra Pradesh has launched a dedicated Key Performance Indicator (KPI) Portal.</a>
                  </div>
                </div>
              </Col>
              <Col xxl={8} xl={7} lg={6} md={12} sm={12} xs={12} className="news-slider-col mt-4 mt-lg-0">
                <div className='news-slider'>
                  <h1>News & <span>Events</span></h1>
                  <SliderComponent {...settings}>
                    {slider.map((slide) => (
                      <div key={slide.id}>
                        <div className='news-slide-box'>
                          <p>{slide.content}</p>
                          <div className='news-slide-box-arrow'>
                            <FaArrowRightLong className='news-arrow' />
                          </div>
                        </div>
                      </div>
                    ))}
                  </SliderComponent>
                </div>
              </Col>
            </Row>
          </div>
        </Container >

        <Container className="slide-container-new">
          <h1>Department wise <span>Key<br />Performance Indicators</span></h1>
          <Swiper
            slidesPerView={5}
            spaceBetween={25}
            loop={true}
            loopFillGroupWithBlank={true}
            grabCursor={true}
            pagination={{ clickable: true, dynamicBullets: true }}
            navigation={true}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            modules={[Navigation, Pagination, Autoplay]}
            breakpoints={{
              0: { slidesPerView: 1 },
              520: { slidesPerView: 1 },
              950: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
              1600: { slidesPerView: 4 },
            }}
          >
            {slidesnew.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className="card card-box">
                  <div className="performance-fourslider-box">
                    <div className="d-flex justify-content-between w-100">
                      <p>{slide.title}</p>
                      <img src={slide.path} alt={slide.title} className="key-icons" />
                    </div>
                    <h2>
                      {slide.count}<span className="d-block fw-normal">Indicators</span>
                    </h2>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Container>
        {/* -------------------------------------------------- */}
        <Container>
          <div className="slider-container key-goals">
            <h1>Key Goals &<br></br><span>Focus Areas</span></h1>
            <button className="custom-arrow custom-prev" aria-label="Previous Slide">
              <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>

            <button className="custom-arrow custom-next" aria-label="Next Slide">
              <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
            <div ref={sliderRef} className="slider mt-3">
              <div className="item">
                <div className="card border-0">
                  <img src="../images/key1.webp" alt="Economic Transformation" className="card-img" />

                  <div className="image-overlay"></div>

                  <div className="big-number">1</div>

                  <div className="overlay-text">
                    <h3>Economic Growth & <br />Sectoral Performance </h3>
                    <p className="slide-description">
                      Monitor GSDP growth and sector-wise contributions from agriculture, industry, and services to ensure alignment with long-term economic targets,
                    </p>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key2.webp" alt="Vision Planning" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Infrastructure & <br />Basic Amenities</h3>
                    <p className="slide-description">Track development of housing, roads, water supply, sanitation, electricity, LPG connections, and digital connectivity across all regions.</p>
                  </div>
                  <div className="big-number">2</div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key3.webp" alt="KPI Portal" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Social Development & <br />Human Capital </h3>
                    <p className="slide-description">
                      Evaluate improvements in literacy, health outcomes, life expectancy, and female labor force participation, with a focus on inclusive growth.
                    </p>
                  </div>
                  <div className="big-number">3</div>
                </div>
              </div>
              <div className="item">
                <div className="card border-0">
                  <img src="../images/key4.png" alt="Economic Transformation" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Employment Generation & <br />Skilling</h3>
                    <p className="slide-description">
                      Assess the reach and impact of skilling programs, industrial parks, MSME support, and job creation initiatives across urban and rural areas.</p>
                  </div>
                  <div className="big-number">4</div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key5.webp" alt="Vision Planning" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Agriculture & <br />Natural Farming</h3>
                    <p className="slide-description">Monitor adoption of sustainable farming practices, agri-tech integration, irrigation coverage, and farmer income enhancement.

                    </p>

                  </div>
                  <div className="big-number">5</div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key6.webp" alt="KPI Portal" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Water Resource <br />Management </h3>
                    <p className="slide-description">
                      Track initiatives related to river interlinking, groundwater regulation, irrigation infrastructure, and water conservation technologies.
                    </p>
                  </div>
                  <div className="big-number">6</div>
                </div>
              </div>
              <div className="item">
                <div className="card border-0">
                  <img src="../images/key7.webp" alt="KPI Portal" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Energy Transition & <br />Climate Resilience</h3>
                    <p className="slide-description">
                      Evaluate progress in renewable energy adoption, rooftop solar implementation, green hydrogen hubs, and climate adaptation measures.</p>
                  </div>
                  <div className="big-number">7</div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key3.webp" alt="KPI Portal" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Urban Development & <br />Clean Environment</h3>
                    <p className="slide-description">
                      Monitor urban infrastructure upgrades, waste management systems, green cover expansion, and livability indices in cities and towns.</p>
                  </div>
                  <div className="big-number">8</div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key4.webp" alt="KPI Portal" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Logistics & <br />Connectivity Infrastructure</h3>
                    <p className="slide-description">
                      Track development of ports, airports, highways, multimodal logistics parks, and inland waterways to enhance trade and mobility.</p>
                  </div>
                  <div className="big-number">9</div>
                </div>
              </div>

              <div className="item">
                <div className="card border-0">
                  <img src="../images/key5.webp" alt="KPI Portal" className="card-img" />
                  <div className="image-overlay"></div>
                  <div className="overlay-text">
                    <h3>Technology & <br />Innovation Ecosystem</h3>
                    <p className="slide-description">
                      Assess the growth of deep-tech hubs, AI-driven governance tools, digital health systems, and innovation platforms supporting MSMEs and startups.</p>
                  </div>
                  <div className="big-number">10</div>
                </div>
              </div>
            </div>
          </div>
        </Container >

      </div >

      <NewFooter />
      <Modal show={padiOneShow} onHide={() => padiOne(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Zero Poverty- P4</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/1-zeropoverty.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>As part of the long-term vision, the State envisages making Andhra Pradesh, a poverty-free State in a span of 5 years. The approach to eradicating poverty is centered around the P4 model - Public, Private, People Partnership. This model integrates economic inclusion with social responsibility, ensuring that the top 10% of society handholds the bottom 20% for upliftment. Through mentorship, financial aid, and skill development, etc.., wealthier sections will actively support underprivileged groups, fostering community-led economic progress. </p>
                <p>The government is committed to ensuring every family has access to house site, house, water supply, sanitation facilities, LPG Gas connection, Electricity and Solar Roof an Digital connectivity. Additionally, it envisions one entrepreneur per family, transforming households into self-sufficient growth centers. Social security measures will include welfare programs for health, education, financial aid, and skilling initiatives, creating a poverty-free and economically empowered Andhra Pradesh. </p></Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={padiTwoShow} onHide={() => padiTwo(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Population Management & Human Resource Development</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/2-PopulationManagement.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>Managing population growth while ensuring human resource development is a key priority for Andhra Pradesh. The government envisions a balanced demographic structure where population stability supports long-term economic and social growth. Special efforts will be made to ensure productive workforce participation, focusing on health, education, and well-being. </p>
                <p>A holistic human resource development approach will be adopted, integrating education, skilling, healthcare, and employment policies to equip the state's population with the capabilities required for the future. Policies will be designed to leverage the youth dividend while ensuring support systems for the elderly and vulnerable sections. </p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={padiThreeShow} onHide={() => padiThree(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Skilling and Employment</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3"><Row>
            <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
              <img src="../images/3-SkillingEmployment.png" className='img-fluid w-100' />
            </Col>
            <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
              <p>The state aims to create widespread employment opportunities across sectors, ensuring economic engagement for every willing individual in both domestic and global markets. Andhra Pradesh will develop world-class industrial parks and townships that provide jobs, housing, and social amenities to boost the local economy.</p>
              <p>A robust ecosystem of skilling and continuous upskilling will be established to position Andhra Pradesh as a Global Knowledge and Services hub. The government will introduce integrated skilling programs from the 6th grade onward, ensuring multi-disciplinary education pathways. Industry-led skilling centers, such as the Ratan Tata Innovation Hub in Amaravati, will be expanded across the state.</p>
              <p>A Unique Skill Passport will be introduced, enabling real-time skill audits and tracking workforce readiness for future jobs. Additionally, women entrepreneurs and MSME parks will receive targeted fiscal support, encouraging inclusive workforce participation.</p>
            </Col>
          </Row>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={padiFourShow} onHide={() => padiFour(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Water Security</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/4-WaterSecurity.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>Ensuring water security is a key priority for sustainable development. The strategy includes interlinking rivers to facilitate equitable water distribution and providing irrigation access to every acre of cultivable land. Adoption of drip irrigation, GIS-enabled water management systems, and rainwater harvesting will enhance water efficiency. The government aims to establish resilient water conservation infrastructure, integrating modern technology with traditional water management practices.</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={padiFiveShow} onHide={() => padiFive(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Farmers - Agri Tech</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/5-FarmerAgri.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>Enhancing farmer incomes while ensuring sustainability is central to this guiding principle. Farmers will receive access to credit, mentorship, and legal support, stabilizing their finances and improving productivity. The AP Community Managed Natural Farming (APCNF) initiative will expand, promoting low-input, climate-resilient farming techniques such as agroforestry and crop rotation. Technology will play a crucial role in modernizing agriculture through AI, IoT, robotics, drones, and satellite-based precision farming. The government will develop specialized agricultural hubs for high-value crops, aquaculture, and horticulture, ensuring global market access.</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={padiSixShow} onHide={() => padiSix(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Global Best Logistics</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/6-GlobalLogistics.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>The logistics framework will position Andhra Pradesh as a global trade hub. This includes modern highways, an extensive rail network, two deep-draft mega ports, and three international airports. Connectivity will be enhanced through hub-to-spoke domestic air networks and multi-modal logistics parks (MMLPs) in key economic zones such as Vizag, Machilipatnam, Anantapur, and Orvakal. The inland waterways system will be upgraded with larger channels and advanced cargo handling facilities to facilitate cost-effective transport. The state will also focus on shipbuilding, repair, and recycling clusters, ensuring global competitiveness.</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={padiSevenShow} onHide={() => padiSeven(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Cost Optimization - Energy and Fuel</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/7-CostEnergyFuel.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>The vision for energy and fuel cost optimization focuses on hybrid energy solutions and Green Hydrogen hubs, ensuring energy efficiency and sustainability. Green corridors will integrate pumped hydro storage, offshore wind infrastructure, waste-to-energy plants, and biogas production. The state is committed to decarbonizing greenhouse gas (GHG) intensive sectors to achieve net-zero emissions by 2047 in the long term. Every household is envisioned as a "greenhouse", leveraging solar rooftop solutions under national schemes like PM KUSUM and PM Surya Ghar Yojana. Andhra Pradesh will establish a Central Climate Knowledge Center with early warning systems in risk-prone districts to support climate resilience.</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={padiEightShow} onHide={() => padiEight(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Product Perfection</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/8-ProductPerfection.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>Andhra Pradesh envisions becoming a hub for innovation and global-standard products. The development of innovation districts will connect global investors, universities, and research institutions. Incubation parks and R&D centers will be established to foster technology-driven product development. To promote Andhra Pradesh as a global brand, large-scale digital expos and participation in global trade events will be encouraged. Additionally, high-quality standards will be enforced across industries to ensure excellence in products and services. </p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={padiNineShow} onHide={() => padiNine(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Swachh Andhra</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/9-SwachhAndhra.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>The vision for Swachh Andhra aligns with the principle of "Swachh Alochana to Swachh Bharat", focusing on equal access to water, sanitation, and hygiene facilities. The implementation of tech-driven waste management systems will improve solid and liquid waste disposal. Andhra Pradesh aims to be home to at least two of the world's top 100 most livable cities, adopting circular economy principles and waste-to-wealth solutions. Green financing initiatives, such as green bonds and carbon credit trading, will further promote environmental sustainability. Conservation efforts will include mangrove restoration and expansion, ensuring a healthier marine ecosystem.</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={padiTenShow} onHide={() => padiTen(false)} size="xl" aria-labelledby="example-modal-sizes-title-sm" >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h5 class="text-center text-dark pt-1">Deep Technology in all walks</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="padi-content p-3">
            <Row>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <img src="../images/10-DeepTech.png" className='img-fluid w-100' />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className=''>
                <p>Andhra Pradesh aims to become a global leader in deep-tech innovation by establishing four world-class technology hubs. The state will focus on AI, data analytics, cybersecurity, and digital services, ensuring real-time governance and predictive analytics for better decision-making. A digital health profiling system will be introduced, enabling AI-driven health monitoring and genetic testing. In tourism, AI-based platforms will provide real-time analytics on market trends and tourist experiences. Additionally, deep-tech-driven MSME digital stacks will support small businesses in accessing credit and technical expertise.</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        tabIndex="0"
        autoComplete="off"
        onHide={handleClose}
        show={addModal}
        animation={false}
      >
        <Modal.Header style={{ backgroundColor: 'rgb(255 240 215)' }} closeButton onClick={closing}>
        </Modal.Header>

        <Modal.Body className="p-0 text-center">
          <img
            src={'../images/unstop.jpeg'}
            alt="Unstop"
            style={{ width: "100%", height: "auto" }}
          />
        </Modal.Body>
      </Modal>

    </>
  );
}